import styled from "styled-components";
import { Logo } from "../../assets/icons/Icon";
import { Link } from "react-router-dom";

export const LogoLine = styled(Link)`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
  align-self: center;
  margin-bottom: 4rem;
  cursor: pointer;
  text-decoration: none;

  @media (max-height: 720px) {
    margin-bottom: 2.5rem;
  }
  @media (max-height: 610px) {
    margin-bottom: 1.5rem;
  }
`;

export const LogoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const LogoName = styled.div`
  font-size: 2rem;
  font-weight: 700;
  text-decoration: none;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.primary};
  letter-spacing: 1.5%;

  @media (max-height: 610px) and (max-width: 1024px) {
    font-size: 1.5rem;
    letter-spacing: 1.9%;
  }
  @media (max-height: 520px) and (max-width: 800px) {
    font-size: 1.25rem;
  }
  @media (max-width: 660px) {
    font-size: 1rem;
  }
  @media (max-height: 600px) {
    font-size: 1.25rem;
  }
  @media (max-height: 490px) {
    font-size: 1rem;
  }
  @media (max-height: 430px) {
    font-size: 0.8rem;
  }
`;

export const LogoLabel = styled.span`
  font-size: 0.66rem;
  font-weight: 600;
  line-height: 0.67rem;
  color: ${({ theme }) => theme.colors.navLink};

  @media (max-height: 610px) and (max-width: 1024px) {
    font-size: 0.5rem;
    line-height: 0.51rem;
    letter-spacing: -1%;
  }
  @media (max-width: 660px) {
    font-size: 0.5rem;
    line-height: 0.51rem;
    letter-spacing: -1%;
  }
  @media (max-height: 490px) and (max-width: 660px) {
    display: none;
  }
  @media (max-height: 430px) {
    display: none;
  }
`;

export const StyledLogo = styled(Logo)`
  width: 68px;
  height: 68px;

  @media (max-width: 660px) {
    width: 48px;
    height: 48px;
  }
  @media (max-height: 600px) {
    width: 48px;
    height: 48px;
  }
  @media (max-height: 490px) {
    width: 40px;
    height: 40px;
  }
  @media (max-height: 430px) {
    width: 32px;
    height: 32px;
  }
  @media (max-height: 390px) {
    width: 24px;
    height: 24px;
  }
`;
